var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { ActionTypes } from './actions';
export var initialState = {
    isLoading: false,
    questionsGroupId: null,
    questionsGroup: null,
    error: null,
};
export var questions = function (state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case ActionTypes.SET_QUESTIONS_GROUP_ID: {
            return __assign(__assign({}, state), { questionsGroupId: action.payload.id });
        }
        case ActionTypes.FETCH_QUESTIONS_GROUP: {
            return __assign(__assign({}, state), { isLoading: true, error: null });
        }
        case ActionTypes.FETCH_QUESTIONS_GROUP_SUCCESS:
            return __assign(__assign({}, state), { isLoading: false, questionsGroup: action.payload.data.questions, error: null });
        case ActionTypes.FETCH_QUESTIONS_GROUP_FAILURE:
            return __assign(__assign({}, state), { isLoading: false, error: action.payload.error });
        case ActionTypes.RESET_QUESTION:
            return {
                isLoading: false,
                questionsGroupId: null,
                questionsGroup: null,
                error: null,
            };
        default:
            return state;
    }
};
